export const navBarItems = [
  {
    label: "Kits Presenteáveis",
    path: "/product-page/kits-presenteaveis",
  },
  {
    label: "Velas Moldadas",
    path: "/product-page/velas-moldadas",
  },
  {
    label: "Velas Container",
    path: "/product-page/velas-container",
  },
  {
    label: "Cuidados de Banho",
    path: "/product-page/cuidados-de-banho",
  },
  {
    label: "Bordados",
    path: "/product-page/bordados",
  },
];
